import { animate, state, style, transition, trigger } from '@angular/animations';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DateAdapter, MatDialog, MatPaginator, MatSort, MatTableDataSource, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ExcelgeneratorService } from 'src/app/services/excelgenerator/excelgenerator.service';
import { UsersService } from 'src/app/services/users/users.service';
import { NgxDateRangePickerOptions } from '../schedulingandplanning/createtriptable/createtriptable.component';
import { CdkDetailRowDirective } from '../userreport/cdk-detail.row';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-ondutyoffdutyreport',
  templateUrl: './ondutyoffdutyreport.component.html',
  styleUrls: ['../userreport/userreport.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})

export class OndutyoffdutyreportComponent implements OnInit {
  columnsToDisplay = [
    'user',
    'department',
    'date',
    'onDutyTime',
    'offDutyTime',
    'dutyHours'
  ];
  userActivityData = new MatTableDataSource;
  options: NgxDateRangePickerOptions;
  daterRangevalue: any;
  prevFromDate: any;
  prevTodate: any;
  selectedValue = [];
  isDateFiltered: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  fromDate: any;
  toDate: any;
  totalRecords = 0;
  private openedRow: CdkDetailRowDirective;
  isLoading: boolean = false;
  excelRecords = [];
  excelDailyRecords = [];
  isRunnerBoyReport: boolean = false;

  constructor(
    private datePipe: DatePipe,
    private userService: UsersService,
    public dialog: MatDialog,
    private excelService: ExcelgeneratorService) { }

  ngOnInit(): void {
    this.createInitialFilter();
    this.getUserActivityData();
  }

  createInitialFilter() {
    this.options = {
      theme: 'default',
      labels: ['Start', 'End'],
      menu: null,
      dateFormat: 'YYYY-MM-DD',
      outputFormat: 'DD-MM-YYYY',
      startOfWeek: 1,
      outputType: 'object',
      locale: 'en',
      date: {
        from: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        },
        to: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate()
        }
      }
    };
    this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.selectedValue = [];
    this.isDateFiltered = true;
  }

  ngAfterViewInit() {
    this.userActivityData.paginator = this.paginator;
    this.userActivityData.sortingDataAccessor = (item: any, property) => {
      switch (property) {
        case 'user': return item.fullName;
      }
    };
    this.userActivityData.sort = this.sort;
  }

  onToggleChange(cdkDetailRow: CdkDetailRowDirective): void {
    if (this.openedRow && this.openedRow.expended) {
      this.openedRow.toggle();
    }
    this.openedRow = cdkDetailRow.expended ? cdkDetailRow : undefined;
  }

  applyFilter(filterValue: string) {
    this.userActivityData.filter = filterValue.trim().toLowerCase();
    this.userActivityData.filterPredicate = (data: any, filter: string) => {
      let isUserName = false, isDepartment = false;
      if (data) {
        if (data.userSummaryReport && data.fullName) {
          isUserName = data.fullName.toString().toLowerCase().indexOf(filter) != -1;
        }
        if (data.userSummaryReport && data.roleName) {
          isDepartment = data.roleName.toString().toLowerCase().indexOf(filter) != -1;
        }
      }
      return isUserName || isDepartment;
    };
  }

  sortByDate() {
    if (!this.daterRangevalue) {
      console.log("Result", this.daterRangevalue, this.selectedValue);
      this.fromDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.getUserActivityData();
      this.prevFromDate = this.fromDate;
      this.prevTodate = this.toDate;
    }

    else if (this.daterRangevalue) {
      this.fromDate = this.daterRangevalue.from.substring(6, 10) + '-' + this.daterRangevalue.from.substring(3, 5) + '-' + this.daterRangevalue.from.substring(0, 2);
      this.toDate = this.daterRangevalue.to.substring(6, 10) + '-' + this.daterRangevalue.to.substring(3, 5) + '-' + this.daterRangevalue.to.substring(0, 2);
      if (this.toDate != this.prevTodate || this.fromDate != this.prevFromDate) {
        this.isDateFiltered = true;
        this.getUserActivityData();
        this.prevFromDate = this.fromDate;
        this.prevTodate = this.toDate;
      }
    }
  }


  getUserActivityData() {
    this.userActivityData.data = [];
    this.isLoading = true;
    this.userService.getOnOffDutyUserData(this.fromDate, this.toDate).subscribe(activity => {
      this.isLoading = false;
      this.userActivityData.data = activity;
      this.totalRecords = this.userActivityData.data.length;
      console.log("User Data", this.userActivityData.data);
    }, () => {
      this.isLoading = false;
      this.userActivityData.data = [];
      this.totalRecords = 0;
    });
  }

  exportAsXLSX(): void {
    this.dataForExcel();
    this.excelService.exportAsExcelFile(this.excelRecords, 'OnDutyOffDutyReport');
  }

  dataForExcel() {
    let userData = [];
    userData = this.userActivityData.data;
    this.excelRecords = [];
    userData.forEach(user => {
      if (user) {
        this.excelRecords.push({
          'User': user.fullName,
          'Phone No.': user.phoneNumber,
          'Department': user.roleName,
          'Date': this.datePipe.transform(user.onDutyDateTime, "dd/MM/yyyy"),
          'On Duty': this.datePipe.transform(user.onDutyDateTime, "medium"),
          'Off Duty': this.datePipe.transform(user.offDutyDateTime, "medium"),
          'Duty Hours': this.minsToHours(user.dutyMinutes) || '',
        });
      }
    });
  }


  minsToHours(totalMins) {
    if (totalMins) {
      var num = totalMins;
      var hours = (num / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return rhours + " : " + rminutes;
    }
    else {
      return 0;
    }
  }

  clearAllFilter() {
    this.paginator.pageIndex = 0;
    this.createInitialFilter();
    this.getUserActivityData();
    this.isDateFiltered = false;
  }
}
